import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MobileFilter from "../../../components/ui/MobileFilter";
import IndeterminateCheckbox from "../../../components/ui/IndeterminateCheckbox";

const MasterScriptHeader = ({
  onFilterChange,
  tableData,
  setDateFilters,
  setIsFilter,
  isFilter,
}) => {
  const schema = z.object({
    role_name: z.string().nonempty(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nonempty(),
  });
  const form = useForm({
    defaultValues: {
      status: "true",
      short_name: "-",
      created_start_date: "",
      created_end_date: "",
      updated_start_date: "",
      updated_end_date: "",
    },
    resolver: zodResolver(schema),
  });
  const [data, setData] = useState([]);
  const [value, setValue] = useState();
  const [createdEndDate, setCreatedEndDate] = useState("");
  const [createdStartDate, setCreatedStartDate] = useState("");
  const [uploadedeEndDate, setUploadedEndDate] = useState("");
  const [uploadedStartDate, setUploadedStartDate] = useState("");
  const [selectedValues, setSelectedValues] = useState({});

  React.useEffect(() => {
    if (tableData) setData(tableData);
  }, [tableData]);

  useEffect(() => {
    setDateFilters(value);
  }, [value]);

  const handleApplyFilters = (selectedValues) => {
    setDateFilters({
      created_start_date: selectedValues?.date_from,
      created_end_date: selectedValues?.date_to,
      updated_start_date: selectedValues?.date_from_2,
      updated_end_date: selectedValues?.date_to_2,
    });
  };
  const scripMasterFilters = [
    {
      name: "date_from",
      label: "Created From",
      type: "date from",
    },
    {
      name: "date_to",
      label: "Created  To",
      type: "date to",
    },
    {
      name: "date_from_2",
      label: "Updated From",
      type: "date from 2",
    },
    {
      name: "date_to_2",
      label: "Updated To",
      type: "date to 2",
    },
  ];

  return (
    <div className="flex flex-row ">
      <div className="mb-8 w-full flex flex-wrap items-baseline justify-between  max-sm:hidden">
        <div className="flex flex-wrap items-baseline gap-4">
          <div className=" flex items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2">
              <label>Created from</label>
              <div className="relative flex w-[170px]"> 
                <CustomDateInput
                  initialValue={form.getValues("created_start_date")}
                  handleSetValue={(val) =>
                    setValue((prev) => ({
                      ...prev,
                      created_start_date: val,
                    }))
                  }
                  className={
                    " w-full bg-neutral-100 px-2 text-[#636363] focus:outline-none"
                  }
                  // min = {createdStartDate}
                  max={createdEndDate}
                />
              </div>
            </div>
          </div>

          <div className=" flex items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2">
              <label>Created to</label>
              <div className="relative flex w-[170px]">
                <CustomDateInput
                  initialValue={form.getValues("created_end_date")}
                  handleSetValue={(val) =>
                    // handleDateChange("created_end_date", val)
                    setValue((prev) => ({
                      ...prev,
                      created_end_date: val,
                    }))
                  }
                  className={
                    " w-full bg-neutral-100 px-2 text-[#636363] focus:outline-none"
                  }
                  min={createdStartDate}
                  // max = {createdEndDate}
                />
              </div>
            </div>
          </div>

          <div className=" flex items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2">
              <label>Updated from</label>
              <div className="relative flex w-[170px]">
                <CustomDateInput
                  initialValue={form.getValues("updated_start_date")}
                  handleSetValue={(val) =>
                    // handleDateChange("updated_start_date", val)
                    setValue((prev) => ({
                      ...prev,
                      updated_start_date: val,
                    }))
                  }
                  className={
                    " w-full bg-neutral-100 px-2 text-[#636363] focus:outline-none"
                  }
                  // min = {uploadedStartDate}
                  max={uploadedeEndDate}
                />
              </div>
            </div>
          </div>

          <div className=" flex items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2">
              <label>Updated to</label>
              <div className="relative flex w-[170px]">
                <CustomDateInput
                  initialValue={form.getValues("updated_end_date")}
                  handleSetValue={(val) =>
                    setValue((prev) => ({
                      ...prev,
                      updated_end_date: val,
                    }))
                  }
                  className={
                    " w-full bg-neutral-100 px-2 text-[#636363] focus:outline-none"
                  }
                  min={uploadedStartDate}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-4 w-fit">
          <div className="flex w-fit flex-col gap-2 text-neutral-600 ">
            <label> </label>
            <div className="mt-[20px] flex w-[200px] items-center gap-2 ">
              <IndeterminateCheckbox
                {...{
                  disabled: false,
                  checked: value?.scrip_and_isin,
                  onChange: (e) => {
                    setValue((prev) => ({
                      ...prev,
                      scrip_and_isin: e.target.checked,
                    }));
                  },
                }}
              />
              Empty Scrip & ISIN
            </div>
          </div>
          <div className="flex w-fit flex-col gap-2 justify-end text-neutral-600">
            <label> </label>
            <div className="mt-[20px] flex w-fit items-center gap-2 ">
              <IndeterminateCheckbox
                {...{
                  disabled: false,
                  checked: value?.scrip_or_isin,
                  onChange: (e) => {
                    setValue((prev) => ({
                      ...prev,
                      scrip_or_isin: e.target.checked,
                    }));
                  },
                }}
              />
              Empty Scrip Or ISIN
            </div>
          </div>
        </div>
      </div>

      {isFilter && (
        <MobileFilter
          filters={scripMasterFilters}
          onApply={handleApplyFilters}
          onClose={() => setIsFilter(false)}
          isFilter={isFilter}
          setSelectedValues={setSelectedValues}
          selectedValues={selectedValues}
          nofinyearDate={true}
        />
      )}
    </div>
  );
};

export default MasterScriptHeader;
